import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    fontSize: 16,
    flexDirection: 'column',
    paddingBottom: '2rem',
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    maxWidth: '90vw',
    padding: '1.5rem',
  },

  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
  },

  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: ' 1rem',
  },

  title: {
    width: '100%',
    color: Colors.white,
    backgroundColor: Colors.primaryColor,
    textAlign: 'center',
    fontSize: '1.7rem',
    padding: '0.5rem',
    borderRadius: 5,
    margin: 0,
  },

  prospectInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    borderRadius: 5,

    '& > p > span': {
      fontWeight: 600,
    },
  },
  
  prospectDetailsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem 0',
    '& > div': {
      maxWidth: 1250,
    },
  },

  section: {
    backgroundColor: Colors.white,
    borderRadius: 5,
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',

    '& div.inner-spacement': {
      margin: '0 1.5rem !important',
    },
  },
}))

export default styles
